export const DETAIL_PAGE_USER_ACTION = 'DETAIL_PAGE_USER_ACTION';
export const DETAIL_PAGE_USER_ACTION_VERSION = '1.1';

export type DetailPageUserActionPayload = {
  searchId: string;
  productDetailKey: string;
  action: 'HOTEL_INFO' | 'REVIEW' | 'SERVICES' | 'MAP' | 'ROOM_INFO' | 'CANCELLATION_POLICY' | 'LUGGAGE_INFO';
  roomId?: string;
};

export type DetailPageUserActionParams = {
  searchId: string;
  productDetailKey: string;
  action: 'HOTEL_INFO' | 'REVIEW' | 'SERVICES' | 'MAP' | 'ROOM_INFO' | 'CANCELLATION_POLICY' | 'LUGGAGE_INFO';
  roomId?: string;
};

export const createDetailPageUserActionPayload = ({
  searchId,
  productDetailKey,
  action,
  roomId,
}: DetailPageUserActionParams): DetailPageUserActionPayload => ({
  searchId,
  productDetailKey,
  action,
  roomId,
});
